import Vue from 'vue'
import Router from 'vue-router'

// layout components
var async_import = file => () => import('@/views/admin/pages/' + file + '.vue')


import Full from '@/container/Full'

// dashboard components
import Sale from '@/views/front_sale/sale'
// import sale_orders from '@/views/admin/pages/sale_orders'
// import shop_stock from '@/views/admin/pages/shop_stock'
// import shop_cash_mng from '@/views/admin/pages/shop_cash_mng'
// import shop_new_vip from '@/views/admin/pages/shop_new_vip'
// import shop_user_saved from '@/views/admin/pages/shop_user_saved'
// import shop_user_prepay from '@/views/admin/pages/shop_user_prepay'
// import shop_ship_order from '@/views/admin/pages/shop_ship_order'
// import shop_recv_order from '@/views/admin/pages/shop_recv_order'
// import shop_pandian_order from '@/views/admin/pages/shop_pandian_order'
// import shop_destroy_order from '@/views/admin/pages/shop_destroy_order'
// import shop_request_order from '@/views/admin/pages/shop_request_order'

import Login from '@/views/session/Login'
import LockScreen from '@/views/session/LockScreen'

/*
import DashboardOne from '@/views/dashboard/DashboardOne'
import DashboardTwo from '@/views/dashboard/DashboardTwo'

// Inbox component
import Inbox from '@/views/inbox/Inbox'

// calendar components
import Calendar from '@/views/calendar/Calendar'

// ui components
import Buttons from '@/views/ui-elements/Buttons'
import Cards from '@/views/ui-elements/Cards'
import Grid from '@/views/ui-elements/Grid'
import List from '@/views/ui-elements/List'
import Menu from '@/views/ui-elements/Menu'
import Slider from '@/views/ui-elements/Slider'
import Snackbar from '@/views/ui-elements/Snackbar'
import Tooltip from '@/views/ui-elements/Tooltip'
import Dialog from '@/views/ui-elements/Dialog'
import Select from '@/views/ui-elements/Select'
import Input from '@/views/ui-elements/Input'
import Checkbox from '@/views/ui-elements/Checkbox'
import Radio from '@/views/ui-elements/Radio'
import Toolbar from '@/views/ui-elements/Toolbar'
import Progress from '@/views/ui-elements/Progress'
import Tabs from '@/views/ui-elements/Tabs'
import Carousel from '@/views/ui-elements/Carousel'
import Chips from '@/views/ui-elements/Chips'
import Datepicker from '@/views/ui-elements/Datepicker'
import Timepicker from '@/views/ui-elements/Timepicker'

// chart components
import VueChartjs from '@/views/charts/VueChartjs'
import VueEcharts from '@/views/charts/VueEcharts'

// maps views
import GoogleMaps from '@/views/maps/GoogleMaps'
import LeafletMaps from '@/views/maps/LeafletMaps'
import JvectorMap from '@/views/maps/JvectorMap'

// Pages views
import Blank from '@/views/pages/Blank'
import Gallery from '@/views/pages/Gallery'
import Pricing from '@/views/pages/Pricing'

// users views
import UserProfile from '@/views/users/UserProfile'
import UsersList from '@/views/users/UsersList'

// drag-drop components
import Vue2Dragula from '@/views/drag-drop/Vue2Dragula'
import VueDraggable from '@/views/drag-drop/Vuedraggable'
import VueDraggableResizeable from '@/views/drag-drop/VueDraggableResizable'

// icons components
import Themify from '@/views/icons/Themify'
import Material from '@/views/icons/Material'

// editor components
import QuillEditor from '@/views/editor/QuillEditor'
import WYSIWYG from '@/views/editor/WYSIWYG'

// form componenets
import FormValidation from '@/views/forms/FormValidation'
import Stepper from '@/views/forms/Stepper'

// session components
import SignUp from '@/views/session/SignUp'


// Data table componenets
import Standard from '@/views/tables/Standard'
import Slots from '@/views/tables/Slots'
import SelectableRows from '@/views/tables/SelectableRows'
import SearchWithText from '@/views/tables/SearchWithText'
*/
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Full,
      // redirect : 'noredirect',
      children: [
        {
          path: '/',
          component: Sale,
          meta: {
            title: 'Sale',
            breadcrumb: 'Dashboard / Dashboard V1'
          }
        },
        {
          path: '/admin/pages/sale_orders',
          component: async_import('sale_orders'),
          meta: {
            title: 'sale_orders',
            breadcrumb: '销售 / 销售详单'
          }

        },
        {
          path: '/admin/pages/miaosha_order',
          component: async_import('miaosha_order'),
          meta: {
            title: 'miaosha_order',
            breadcrumb: '秒杀订单'
          }

        },
        /*{
          path: '/admin/pages/shop_stock',
          component: async_import('shop_stock'),
          meta: {
            title: 'shop_stock',
            breadcrumb: '店内库存'
          }

        },
        {
          path: '/admin/pages/shop_cash_mng',
          component: async_import('shop_cash_mng'),
          meta: {
            title: 'shop_stock',
            breadcrumb: '店内库存'
          }

        },
        {
          path: '/admin/pages/shop_new_vip',
          component: async_import('shop_new_vip'),
          meta: {
            title: 'shop_new_vip',
            breadcrumb: '新增会员'
          }

        },
        {
          path: '/admin/pages/shop_user_saved',
          component: async_import('shop_user_saved'),
          meta: {
            title: 'shop_user_saved',
            breadcrumb: '用户暂存'
          }

        },
        {
          path: '/admin/pages/shop_user_prepay',
          component: async_import('shop_user_prepay'),
          meta: {
            title: 'shop_user_prepay',
            breadcrumb: '用户充值'
          }

        },{
          path: '/admin/pages/shop_ship_order',
          component: async_import('shop_ship_order'),
          meta: {
            title: 'shop_ship_order',
            breadcrumb: '店铺调拨'
          }

        },{
          path: '/admin/pages/shop_recv_order',
          component: async_import('shop_recv_order'),
          meta: {
            title: 'shop_ship_order',
            breadcrumb: '店铺收货'
          }

        }
        ,{
          path: '/admin/pages/shop_pandian_order',
          component: async_import('shop_pandian_order'),
          meta: {
            title: 'shop_ship_order',
            breadcrumb: '店铺盘点'
          }

        },{
          path: '/admin/pages/shop_destroy_order',
          component: async_import('shop_destroy_order'),
          meta: {
            title: 'shop_destroy_order',
            breadcrumb: '店铺报损'
          }
        },{
          path: '/admin/pages/shop_request_order',
          component: async_import('shop_request_order'),
          meta: {
            title: 'shop_request_order',
            breadcrumb: '店铺报损'
          }
        }
        // {
        //   path: '/inbox',
        //   component: Inbox,
        //   meta: {
        //     title: 'Inbox',
        //     breadcrumb: 'Inbox'
        //   }
        // },
        // {
        //   path: '/calendar',
        //   component: Calendar,
        //   meta: {
        //     title: 'Calendar',
        //     breadcrumb: 'Calendar'
        //   }
        // }
        */
      ]
    },
    {
      path: '/login',
      component: Login,
      meta: {
        title: 'Login',
        breadcrumb: 'Session / Login'
      }
    },
    {
      path: '/lock-screen',
      component: LockScreen,
      meta: {
        title: 'Lock Screen',
        breadcrumb: 'Session / Lock Screen'
      }
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js